import { render } from "./PaymentItem.vue?vue&type=template&id=4ee50eec&scoped=true"
import script from "./PaymentItem.vue?vue&type=script&lang=js"
export * from "./PaymentItem.vue?vue&type=script&lang=js"

import "./PaymentItem.vue?vue&type=style&index=0&id=4ee50eec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee50eec"]])

export default __exports__